import React, { useState } from 'react';
import { useLocation, } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField, Grid, Button, Typography, FormControlLabel, Switch, MenuItem, Box, CircularProgress } from '@material-ui/core';
import InputMask from 'react-input-mask';

import TituloPagina from '../../components/layout/TituloPagina';
import If from '../../components/condicional/if';
import { buscarUsuarioPorCpf } from '../../store/actions/usuario';
import { buscarNegocioPorCpfOuCnpj } from '../../store/actions/negocio';
import { addFuncionario } from '../../store/actions/funcionario';
import DialogAlert from '../../components/layout/DialogAlert';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const FuncionarioCadastro = props => {
    const {
        negocioDoUsuario,
        usuarioCadastroFuncionario,
        negocioCadastroFuncionario,
        buscarUsuarioPorCpf,
        buscarNegocioPorCpfOuCnpj,
        addFuncionario,
        loading,
        processing,
        user
    } = props;
    const { perfis } = user;
    const location = useLocation();
    const [disableFields, setDisableFields] = useState(false);
    const [cpfUsuario, setCpfUsuario] = useState('');
    const [cpfOuCnpjNegocio, setCpfOuCnpjNegocio] = useState('');
    const [tipoNegocio, setTipoNegocio] = useState('');
    const [toggleDialog, setToggleDialog] = useState(false);
    const [mensagemErro, setMensagemErro] = useState('');
    const [processingMessage, setProcessingMessage] = useState('');
    const from = location.state?.from;
    const isPlatformAdmin = Array.isArray(perfis) && perfis.includes('ADMIN_APP');

    const validationSchema = yup.object({
        matricula: yup.string()
            .required('O Número de Identificação Funcional é obrigatório'),
    });

    const formik = useFormik({
        initialValues: {
            matricula: '',
            dataAdmissao: null,
            dataDesligamento: null,
            ativo: false
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            if ((isPlatformAdmin && Object.keys(negocioCadastroFuncionario).length === 0) || (!isPlatformAdmin && !negocioDoUsuario > 0)) {
                setMensagemErro('Você precisa identificar o negócio ao qual o funcionário ficará vinculado.');
                setToggleDialog(true);
                return;
            }
            if (Object.keys(usuarioCadastroFuncionario).length === 0) {
                setMensagemErro('Você precisa identificar o funcionário.');
                setToggleDialog(true);
                return;
            }

            setProcessingMessage('Salvando...');

            const data = {
                ...values,
                dataDemissao: values.dataDesligamento,
                idNegocio: isPlatformAdmin ? negocioCadastroFuncionario.id : negocioDoUsuario,
                idUsuario: usuarioCadastroFuncionario.id
            };
            addFuncionario(data);

            setProcessingMessage('');
            setDisableFields(true);
        },
        enableReinitialize: true,
    });

    function handleBuscarUsuario() {
        buscarUsuarioPorCpf(cpfUsuario);
    }

    function handleBuscarNegocio() {
        buscarNegocioPorCpfOuCnpj(cpfOuCnpjNegocio);
    }

    function handleDialogError() {
        setToggleDialog(false);
        setMensagemErro('');
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Cadastro de Funcionário' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Grid container item xs={12}>
                {isPlatformAdmin && (
                    <>
                        <Grid container style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                            <Typography variant='body1' component='p'>
                                Identifique o negócio
                            </Typography>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    id='codigoTipo'
                                    name='codigoTipo'
                                    label='Tipo de Pessoa'
                                    variant='filled'
                                    value={tipoNegocio}
                                    disabled={disableFields}
                                    onChange={event => setTipoNegocio(event.target.value)}>
                                    <MenuItem key='1' value={1}>Pessoa Física</MenuItem>
                                    <MenuItem key='2' value={2}>Pessoa Jurídica</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputMask
                                    mask={tipoNegocio === 1 ? '999.999.999-99' : '99.999.999/9999-99'}
                                    maskChar=' '
                                    value={cpfOuCnpjNegocio}
                                    disabled={disableFields}
                                    onChange={event => setCpfOuCnpjNegocio(event.target.value)}>
                                    {() => <TextField
                                        fullWidth
                                        id='cpfOuCnpjNegocio'
                                        name='cpfOuCnpjNegocio'
                                        label='CPF/CNPJ do Negócio'
                                        variant='filled'
                                    />}
                                </InputMask>
                            </Grid>
                            <Grid item xs={12} sm={4} style={{ alignItems: 'baseline', justifyContent: 'center' }}>
                                <Button variant='contained' color='secondary' onClick={handleBuscarNegocio}>Pesquisar</Button>
                            </Grid>
                        </Grid>

                        <div style={{ flexGrow: 1, paddingTop: '15px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        id='nome'
                                        name='nome'
                                        label='Nome'
                                        variant='filled'
                                        disabled={true}
                                        value={negocioCadastroFuncionario?.nome ?? ''}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth
                                        id='cpfOuCnpj'
                                        name='cpfOuCnpj'
                                        label='CPF/CNPJ'
                                        variant='filled'
                                        disabled={true}
                                        value={negocioCadastroFuncionario?.cpfOuCnpj ?? ''}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        fullWidth
                                        id='contato'
                                        name='contato'
                                        label='Contato'
                                        variant='filled'
                                        disabled={true}
                                        value={negocioCadastroFuncionario?.contato ?? ''}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </>
                )}

                <Grid container style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                    <Typography variant='body1' component='p'>
                        Identifique o funcionário
                    </Typography>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <InputMask
                            mask={'999.999.999-99'}
                            maskChar=' '
                            value={cpfUsuario}
                            disabled={disableFields}
                            onChange={event => setCpfUsuario(event.target.value)}>
                            {() => <TextField
                                fullWidth
                                id='cpfUsuario'
                                name='cpfUsuario'
                                label='CPF do Funcionário'
                                variant='filled'
                            />}
                        </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={4}></Grid>
                    <Grid item xs={12} sm={4} style={{ alignItems: 'baseline', justifyContent: 'flex-end' }}>
                        <Button variant='contained' color='secondary' onClick={handleBuscarUsuario}>Pesquisar</Button>
                    </Grid>
                </Grid>

                <div style={{ flexGrow: 1, paddingTop: '15px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id='nome'
                                name='nome'
                                label='Nome'
                                variant='filled'
                                disabled={true}
                                value={usuarioCadastroFuncionario?.nomeCompleto ?? ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id='cpfOuCnpj'
                                name='cpfOuCnpj'
                                label='CPF'
                                variant='filled'
                                disabled={true}
                                value={usuarioCadastroFuncionario?.cpfOuCnpj ?? ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id='dataNascimento'
                                name='dataNascimento'
                                label='Data de Nascimento'
                                variant='filled'
                                disabled={true}
                                value={usuarioCadastroFuncionario?.dataNascimento ?? ''}
                                InputProps={{ readOnly: true }}
                            />
                        </Grid>
                    </Grid>
                </div>

                <Grid container style={{ paddingTop: '15px' }}>
                    <Typography variant='body1' component='p'>
                        Informe abaixo os dados do funcionário
                    </Typography>
                </Grid>

                <form onSubmit={formik.handleSubmit} noValidate autoComplete='off' style={{ width: 'inherit' }}>
                    <div style={{ flexGrow: 1, paddingTop: '15px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    id='matricula'
                                    name='matricula'
                                    label='Número de Identificação Funcional'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.matricula}
                                    onChange={formik.handleChange}
                                    error={formik.touched.matricula && Boolean(formik.errors.matricula)}
                                    helperText={formik.touched.matricula && formik.errors.matricula} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputMask
                                    mask={'99/99/9999'}
                                    maskChar=' '
                                    disabled={disableFields}
                                    value={formik.values.dataAdmissao}
                                    onChange={formik.handleChange}>
                                    {() => <TextField
                                        fullWidth
                                        id='dataAdmissao'
                                        name='dataAdmissao'
                                        label='Data de Admissão'
                                        variant='filled'
                                        error={formik.touched.dataAdmissao && Boolean(formik.errors.dataAdmissao)}
                                        helperText={formik.touched.dataAdmissao && formik.errors.dataAdmissao}
                                    />}
                                </InputMask>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <InputMask
                                    mask={'99/99/9999'}
                                    maskChar=' '
                                    disabled={disableFields}
                                    value={formik.values.dataDesligamento}
                                    onChange={formik.handleChange}>
                                    {() => <TextField
                                        fullWidth
                                        id='dataDesligamento'
                                        name='dataDesligamento'
                                        label='Data de Desligamento'
                                        variant='filled'
                                        error={formik.touched.dataDesligamento && Boolean(formik.errors.dataDesligamento)}
                                        helperText={formik.touched.dataDesligamento && formik.errors.dataDesligamento}
                                    />}
                                </InputMask>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch
                                        checked={formik.values.ativo}
                                        onChange={formik.handleChange}
                                        name="ativo"
                                        disabled={disableFields} />}
                                    label="Funcionário Ativo"
                                />
                            </Grid>
                        </Grid>
                        <Grid container pt={4} style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                            <If test={!disableFields}>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button type='submit' color='secondary' variant='contained'>Salvar</Button>
                                </Grid>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button variant='contained' href={from}>Cancelar</Button>
                                </Grid>
                            </If>
                            <If test={disableFields}>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button color='secondary' variant='contained' href={from}>Voltar</Button>
                                </Grid>
                            </If>
                        </Grid>
                    </div>
                </form>
            </Grid>

            <DialogAlert
                title='Atenção'
                okButton={true}
                labelOkButton='Ok'
                okButtonClick={handleDialogError}
                openDialog={toggleDialog}>
                {mensagemErro}
            </DialogAlert>

            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={processing}
                message={processingMessage}
            />
        </>
    )
}

const mapStateToProps = state => ({
    negocioDoUsuario: state.negocio.negocioDoUsuario,
    loading: state.funcionario.loading,
    usuarioCadastroFuncionario: state.usuario.usuarioCadastroFuncionario,
    negocioCadastroFuncionario: state.negocio.negocioCadastroFuncionario,
    processing: state.funcionario.processing,
    user: state.auth.user,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    buscarUsuarioPorCpf,
    buscarNegocioPorCpfOuCnpj,
    addFuncionario
}, dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(FuncionarioCadastro);